import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const PaymentCancel = () => {
  const navigate = useNavigate();
  
  return (
    <Container className="mt-5">
      <Card className="text-center">
        <Card.Header as="h5" className="bg-warning text-dark">
          Payment Cancelled
        </Card.Header>
        <Card.Body>
          <i className="bi bi-x-circle text-warning" style={{ fontSize: '4rem' }}></i>
          <Card.Title className="mt-3">Subscription Not Completed</Card.Title>
          <Card.Text>
            Your payment process was cancelled. No charges have been made. You can try again or continue with your current plan.
          </Card.Text>
          <Button 
            variant="primary" 
            onClick={() => navigate('/subscription')}
            className="me-3"
          >
            Try Again
          </Button>
          <Button 
            variant="outline-secondary" 
            onClick={() => navigate('/dashboard')}
          >
            Back to Dashboard
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PaymentCancel;
